import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import Staff from "../shared/about/Staff"
import HeadingM from "../shared/HeadingM"

// nameの下に本来あった記述。この2つのフィールドは現状使用していないので空のまま呼び出すとエラーになる。そのため削除
// duties
// qualifications

// items変数のmap定義内にあって記述。こちらも同様にエラーんあるので削除
// duties: item.duties,
// qualifications: item.qualifications,

const query = graphql`
  {
    allContentfulSuteaStaff(sort: { fields: order, order: ASC }) {
      nodes {
        role
        name
        comment {
          comment
        }
        image {
          gatsbyImageData
        }
      }
    }
  }
`

const AboutStaff = () => {
  const data = useStaticQuery(query)
  const items = data.allContentfulSuteaStaff.nodes.map(item => ({
    image: getImage(item.image),
    name: item.name,
    position: item.role,
    comment: item.comment.comment,
  }))
  return (
    <div>
      <HeadingM title="スタッフ紹介" target="sutea" />
      <Staff items={items} target="sutea" />
    </div>
  )
}

export default AboutStaff
